import React, {useEffect, useState} from "react";

import "./Styles.css";

const ModalTempoReal = ({close, visible}) => {

    const [modalVisible, setModalVisible] = useState(false)

    useEffect(() => {
        setModalVisible(visible)
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [visible])

    return (
        <React.Fragment>
            {   !modalVisible ? null : 
                <div id="modal-tempo-real" className="modal-tempo-real">
                    <div className="modal-conteudo">
                        <div className="container-topo">
                            <div className="close" onClick={close}></div>
                            <span className="titulo-modal">Alertas TIM</span>
                        </div>
                        <div className="container-lista">
                            <div className="container-comunicado">
                                <span className="comunicado-legenda">Comunicado de melhorias</span>
                                <span className="comunicado">Não existem comunicados para essa localidade.</span>
                            </div>
                            <div className="container-comunicado">
                                <span className="comunicado-legenda">Otimizações programadas</span>
                                <span className="comunicado">Não existe nenhuma otimização programada nesta localidade.</span>
                            </div>
                            <div className="container-comunicado">
                                <span className="comunicado-legenda">Atividades emergenciais</span>
                                <span className="comunicado">Não existe nenhuma atividade emergencial nesta localidade.</span>
                            </div>
                            <div className="container-comunicado">
                                <span className="comunicado-legenda">Interrupções recentes</span>
                                <span className="comunicado">Não há interrupções recentes para esta área.</span>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}

export default ModalTempoReal